import { ExamRoomRequestInfoProvider } from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Navigate, useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ExamRoomRequestLayout() {
  const { roomRequestId, examCenterCode } = useParams(
    '/:examCenterCode/exam-location/requests/draft/:requestId/room/:roomRequestId',
  );

  if (!roomRequestId) {
    return (
      <Navigate to='/:examCenterCode/exam-location/requests' params={{ examCenterCode }} replace />
    );
  }

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.CREATE,
        APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.UPDATE,
        APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <ExamRoomRequestInfoProvider roomRequestId={roomRequestId} examCenterCode={examCenterCode}>
        <Outlet />
      </ExamRoomRequestInfoProvider>
    </PermissionGuard>
  );
}
